import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/authentication/login-callback")({});
